import Form from 'mobx-react-form';
import plugins from './plugins';


const fields = {
    clientSecret: {
        label: 'Client Secret',
        rules: 'string|required',
    },
    clientId: {
        label: 'Client App Id',
        rules: 'string|required',
    },
    tenant: {
        label: 'Tenant Id',
        rules: 'required|string',
    },
};

class AzureAdForm extends Form {
    constructor(setup, options) {
        super({ fields, ...setup }, { plugins, ...options });
    }
}

export default AzureAdForm;
